import {
  GET_VENDOR_MEMBERS_REQUEST,
  GET_VENDOR_MEMBERS_SUCCESS,
  GET_VENDOR_MEMBERS_FAILURE,
} from "./type";

export const getVendorMembersRequest = (data) => {
  return { type: GET_VENDOR_MEMBERS_REQUEST, payload: data };
};

export const getVendorMembersSuccess = (data) => {
  return { type: GET_VENDOR_MEMBERS_SUCCESS, payload: data };
};

export const getVendorMembersFailure = (data) => {
  return { type: GET_VENDOR_MEMBERS_FAILURE, payload: data };
};
